export const memberRights = [
  {
    title: {
      img: require('@/assets/images/members-right-bsc.png'),
      label: ''
    },
    desc: '中国规模最大、影响力辐射全球的国际化网络安全交流盛会，已成功举办7届，每年吸引近五万人参会，是网络安全界的达沃斯硬核安全大会。',
    pics: [
      require('@/assets/images/members-right-bsc1.png'),
      require('@/assets/images/members-right-bsc2.png')
    ],
    list: [
      '参与威胁情报生态联盟展团，为威胁情报生态联盟成员在BCS大会提供展览便利。',
      '为联盟成员贤良提供BCS大会期间产品发布，演讲议题等参会及活动权益',
      '联盟成员在BCS会刊的优先传播权',
      '联盟成员LOGO在大会印刷完，网页等传播素材露出'
    ]
  },
  {
    title: {
      img: require('@/assets/images/members-right-ck.png'),
      label: ''
    },
    desc: '中国最专业和悠久的网络安全创投平台，聚集了众多网络安全领域优秀的明星初创企业，自2016年启动以来，通过创客沙龙、年度明星赛、创业培训等一系列各类主题活动及服务，参赛企业赛后累计总融资额超过12亿元。',
    pics: [
      require('@/assets/images/members-right-ck1.png'),
      require('@/assets/images/members-right-ck2.png')
    ],
    list: [
      '凡符合大赛要求的联盟企业可以直接进入线下半决赛环节。',
      '联盟企业优先获得十大网安创投基金交流及直接投资机会，基金资金池过百亿。',
      '联盟企业优先获得天津、南京产业园相关优惠政策（场地、税收、人才）'
    ]
  },
  {
    title: {
      img: '',
      label: '奇智威胁情报峰会'
    },
    desc: '中国最悠久，最专业，最具影响力的威胁情报年度盛会，已成功举办3届，每年吸引近千人参会。前瞻性的主题、丰富的展区，专业的议程为中国威胁情报行业提供最硬核的交流平台。',
    pics: [
      require('@/assets/images/members-right-qz1.png'),
      require('@/assets/images/members-right-qz2.png')
    ],
    list: [
      '联盟成员优先获得“奇智威胁情报峰会”的展位。',
      '联盟成员可优先提交峰会演讲议题（演讲人，议题需经审核峰会委员会审核）。',
      '审定的联盟成员可参加峰会晚宴。'
    ]
  }
]

export const members = [
  require('@/assets/images/member/member-1.png'),
  require('@/assets/images/member/member-2.png'),
  require('@/assets/images/member/member-3.png'),
  require('@/assets/images/member/member-4.png'),
  require('@/assets/images/member/member-5.png'),
  require('@/assets/images/member/member-6.png'),
  require('@/assets/images/member/member-7.png'),
  require('@/assets/images/member/member-8.png'),
  require('@/assets/images/member/member-9.png'),
  require('@/assets/images/member/member-10.png'),
  require('@/assets/images/member/member-11.png'),
  require('@/assets/images/member/member-12.png'),
  require('@/assets/images/member/member-13.png'),
  require('@/assets/images/member/member-14.png'),
  require('@/assets/images/member/member-15.png'),
  require('@/assets/images/member/member-16.png'),
  require('@/assets/images/member/member-17.png')
]

export const bannerImg = [
  require('@/assets/images/newBanner-01.png')
  // require('@/assets/images/newBanner-03.png')
]

export const specialMembers = [
  {
    title: {
      label: '',
      pic: require('@/assets/images/qax-logo.png')
    },
    desc: `<p>奇安信科技集团股份有限公司（以下简称奇安信）成立于2014年，专注于网络空间安全市场，为向政府、企业用户提供新一代企业级网络安全产品和服务。凭借持续的研发创新和以实战攻防为核心的安全能力，已发展成为国内领先的基于大数据、人工智能和安全运营技术的网络安全供应商。同时，奇安信是2022年冬奥会和冬残奥会网络安全服务与杀毒软件的官方赞助商；此外，公司已在印度尼西亚、新加坡、加拿大、中国香港等国家和地区开展网络安全业务。</p>
  <p>奇安信面向新型基础设施建设、面向数字化业务，运用系统工程的方法论，结合“内生安全”思想，将新一代网络安全框架作为顶层设计指导，以“数据驱动安全”为技术理念、以打造网络安全颠覆性和非对称性能力为目标、以“人+机器”协同运营为手段，创建了面向万物互联时代的网络安全协同联动防御体系。奇安信拥有完备的网络安全产品和创新的网络安全服务，完善的研发、采购、生产和销售模式。针对云计算、大数据、物联网、移动互联网、工业互联网和5G等新技术下产生的新业态、新业务和新场景，为政府与企业等用户提供全面、有效的网络安全解决方案。</p>
  <p>近年来奇安信以高投入研发下的技术创新为引领，特别针对云计算、大数据、移动互联网、工业互联网、物联网等新技术运用下产生的新业态、新场景，为政府与企业等机构客户提供全面有效的网络安全解决方案，率先提出并成功实践“数据驱动安全”“44333”“内生安全”等先进的安全理念，推出了“天狗”系列第三代安全引擎，零信任、“天眼”等创新的安全产品，并于2020年发布面向新基建的新一代网络安全框架，此框架下的"十大工程五大任务"，可以适用于各个应用场景，能指导不同的行业输出符合其业务特点的网络安全架构。</p>
  <p>奇安信重点涵盖了网络安全行业多个前沿领域，包括建设云和大数据安全防护与管理运营中心、物联网安全防护与管理系统、工业互联网安全服务中心、安全服务化项目、基于“零信任”的动态可信访问控制平台，以及网络空间测绘与安全态势感知平台。其中，工业互联网安全服务中心将构建全国性的三级工业互联网安全服务中心体系，为4000家以上工业互联网企业及工业关键基础设施建立安全管理中心，提供工业安全防护、监测、安全托管服务；针对目前市场上云安全和大数据安全的有效防护产品和方案稀缺的现状，奇安信的云和大数据安全防护与管理运营中心项目将通过构建能力平台、产品体系和服务中心三部分，全面提升奇安信全方位安全防护的服务能力。</p>`
  },
  {
    title: {
      label: '',
      pic: require('@/assets/images/member/member-5.png')
    },
    desc: `<p>北京天际友盟信息技术有限公司，成立于2015年，总部设在北京。一直以来，天际友盟秉承“创造安全价值”的品牌理念，以安全能力出发，以产品与服务落地，致力于为客户解决业务安全风险，提供真正的业务价值。</p>
  <p>天际友盟在北京、西安、石家庄三地设有研发中心，技术骨干均为国内安全行业的专家人才，有着超过10年的安全从业经验，对安全情报、数字风险、大数据分析等领域有着深入的了解和丰富的实践经验。</p>
  <p>天际友盟目前在上海、深圳、重庆、西安、沈阳、长春、哈尔滨、长沙、石家庄、太原等多地设有办事处，为全国各地的客户及合作伙伴提供贴身、高效、优质的服务。</p>
  <p>目前，天际友盟旗下有两大类业务：安全情报应用和数字品牌保护。</p>`
  }
]

export const directorMembers = [
  {
    title: {
      label: '',
      pic: require('@/assets/images/member/member-9.png')
    },
    desc: `<p>北京志翔科技股份有限公司由多位安全领域的精英共同创办，注册资本5896万元，由国家开发投资公司旗下基金主导投资。公司总部位于北京，在南京、上海、深圳和广州等多地设有分公司及分支机构。公司核心团队全部毕业于清华大学，及卡耐基.梅隆等国际名校，具有典型的清华风格。公司专注于为客户提供大数据安全产品及服务，产品主要围绕两大方向：一类，保护政府和企业核心数据和文件的安全，防止内、外部人员窃取（如防范斯诺登事件）；第二类，基于日志数据和用户行为习惯，借助大数据分析和深度学习等技术手段，及时发现正在或将要发生的威胁和风险。目前，公司产品已应用于金融行业、政府核心部门、国家电网、医疗教育、高科技企业等多行业及领域客户。志翔科技是2017年IDC中国大数据安全创新者，2018年安全牛中国网络安全50强企业。2019-2020年，志翔科技的至明产品连续两年入选Gartner《云工作负载保护平台市场指南》。</p>`
  },
  {
    title: {
      pic: require('@/assets/images/member/member-2.png')
    },
    desc: `<p>北京派网软件有限公司是业内领先的从网络接入、流量分析、应用提速、带宽优化到七层要素审计的解决方案供应商。基于广受好评的网络应用识别优化引擎以及业界领先的 PanaOS 操作系统，自主研发有 Panabit 智能应用网关、Panalog 大数据日志分析平台、iXCache 互联网智能应用缓存、下一代负载均衡、SD-WAN 应用加速网关等解决方案，致力于提高网络经营中应用可视化、成本调优、行为管理和审计等能力，为用户提供高效、稳定、开放的应用层网络通信平台、产品和服务。</p>
  <p>Panabit 在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过 5000 个运营级案例，以高性能、高稳定性而享誉运营商及高校客户群体；在企业级市场（SMB、政企、网吧、酒店等）拥有超过 60000 家用户和 30000 家免费版用户。</p>`
  }
]

export const commonMembers = [{
  title: {
    label: '',
    pic: require('@/assets/images/member/member-9.png')
  },
  desc: `<p>北京志翔科技股份有限公司由多位安全领域的精英共同创办，注册资本5896万元，由国家开发投资公司旗下基金主导投资。公司总部位于北京，在南京、上海、深圳和广州等多地设有分公司及分支机构。公司核心团队全部毕业于清华大学，及卡耐基.梅隆等国际名校，具有典型的清华风格。公司专注于为客户提供大数据安全产品及服务，产品主要围绕两大方向：一类，保护政府和企业核心数据和文件的安全，防止内、外部人员窃取（如防范斯诺登事件）；第二类，基于日志数据和用户行为习惯，借助大数据分析和深度学习等技术手段，及时发现正在或将要发生的威胁和风险。目前，公司产品已应用于金融行业、政府核心部门、国家电网、医疗教育、高科技企业等多行业及领域客户。志翔科技是2017年IDC中国大数据安全创新者，2018年安全牛中国网络安全50强企业。2019-2020年，志翔科技的至明产品连续两年入选Gartner《云工作负载保护平台市场指南》。</p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-7.png')
  },
  desc: `<p>盛邦安全是网络空间资产安全治理的领航者，致力于让网络空间更有序。盛邦安全率先提出“安全有道，治理先行”的安全治理理念，打造了以资产发现为起点、贯穿网络资产全生命周期的“五步法”安全治理体系。通过持续精进全栈漏洞威胁检测和应用安全防御两大核心技术能力，盛邦安全研发并推出了安全检测、安全防护、云安全和烽火台等一系列安全产品以及与行业应用深度融合的创新安全解决方案，助力各行业客户做到精准识别、精确防御。</p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-2.png')
  },
  desc: `<p>北京派网软件有限公司是业内领先的从网络接入、流量分析、应用提速、带宽优化到七层要素审计的解决方案供应商。基于广受好评的网络应用识别优化引擎以及业界领先的 PanaOS 操作系统，自主研发有 Panabit 智能应用网关、Panalog 大数据日志分析平台、iXCache 互联网智能应用缓存、下一代负载均衡、SD-WAN 应用加速网关等解决方案，致力于提高网络经营中应用可视化、成本调优、行为管理和审计等能力，为用户提供高效、稳定、开放的应用层网络通信平台、产品和服务。</p>
  <p>Panabit 在国内三大运营商、各大广电运营商、驻地网运营商、高校拥有超过 5000 个运营级案例，以高性能、高稳定性而享誉运营商及高校客户群体；在企业级市场（SMB、政企、网吧、酒店等）拥有超过 60000 家用户和 30000 家免费版用户。</p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-1.png')
  },
  desc: `<p>北京安赛创想科技有限公司（简称：安赛）位于北京市海淀区，公司致力于为企业提供真实有效的安全解决方案，是业界知名的信息安全公司。安赛是工信部教育与考试中心批准的全国信息技术人才培养工程培训基地、是国家互联网应急中心认可的CNVD国家信息安全漏洞共享平台技术合作单位、是中国信息安全测评中心认可的CNNVD国家信息安全漏洞库技术支撑单位，是国家信息技术安全研究中心认可的网络空间联合实验室成员，是OWASP授权的CWASP全国唯一授权培训中心，是国家高新技术企业、国家双软企业、中关村雏鹰企业、中关村金种子企业、中国信息安全技术突出成就企业、中关村信息安全产业联盟成员单位。公司自成立以来，先后获得了ISO9001认证、2013年度中国信息安全金融行业优秀解决方案、创新中国百佳示范企业等资质和荣誉，其产品和服务已被三十余家大型互联网企业、十多个部委及各大信息安全主管部门采用并发挥了重要作用，具备极高的口碑和知名度。无论是在信息安全理念还是信息安全技术领域，安赛科技将始终走在中国信息安全产业的前沿，以信息安全为己任，不断开拓、创新，向成为世界级信息安全企业的目标迈进。</p>
  <p>安赛（AISEC）具备优秀的自主研发能力和创新能力。旗下具备漏洞扫描、Web应用防火墙（WAF）、Web入侵检测与漏洞感知系统（WebIDS）、APT防护系统等多项基于应用层的网络安全产品。其自主研发的漏洞扫描产品《AIScanner安全检测系统》先后通过了国家信息安全产品“Web应用安全扫描产品”和“网络脆弱性扫描产品” 增强级(业界最高级别)认证；《安赛Web应用防火墙（WAF）》、《安赛Web入侵检测与漏洞感知系统（WebIDS）》、《安赛APT检测系统》也先后通过了国家信息安全产品认证，目前已广泛应用于金融、通信、军队等重要领域，并已被多个行业监管机构和等级保护单位使用。 </p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-8.png')
  },
  desc: `<p>云溪科技创立于2019年3月，2020年上半年完成天使轮融资。云溪科技聚焦于多云、混合云场景下的云内工作负载安全防护领域，提出自适应统一安全管控架构，并自主研发了自适应云安全管控系统。该产品以安全可控为最终目标，以可见、可管、可控为核心要素，通过创新性云内工作负载检测、防护技术，并融入自适应安全策略、进程级微隔离等创新方法，将云内服务器的预测、防御、监控和响应有力融合，帮助用户在多云、混合云等多样化业务环境下，全方位保护企业数字资产的安全。</p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-6.png')
  },
  desc: `<p>网宿科技（300017）于2000年1月在中国上海成立，公司致力于大数据和云计算基础设施等方面的关键技术研究。公司在全球范围内构建了广泛高效的内容分发（CDN）、边缘计算网络，满足用户随时随地的数据计算及交互需求。<p>
  <p>基于强大的数据分发及处理能力，网宿科技提供CDN、云安全、SD-WAN、云计算、边缘计算等丰富的产品及服务。网宿智能平台日均处理万亿级的服务请求，每天为全球网站抵御超过33亿次攻击，服务全球数十亿网民。</p>
  <p>2019年，网宿科技实现营业收入60.08亿元亿元。在中国商用CDN市场中，网宿份额占比达31.5%，连续多年市场份额位列第一。</p>
  <p>网宿科技在全球部署了超过1500个CDN节点、10+大型流量清洗中心，拥有广泛高效的资源储备，可承载超过15Tbps DDoS攻击，并与近100家海外运营商建立起合作关系，打通了跨网传输瓶颈，能够为各个行业、各大客户的定制化需求提供稳定、高效的服务。</p>
  <p>网宿科技在美国、俄罗斯、韩国、中国厦门和中国深圳设立五大研发中心，拥有顶级的技术研发团队，研发人员数量占比超过65%，每年研发投入占公司营业收入10%左右。</p>
  <p>网宿遍布六大洲的全球化运营平台同时为7*24小时的可靠服务保驾护航，其定制化服务能力在十九大、上合峰会、春晚、世界杯、电商购物节等多项重大活动中得到了验证。在历年来的重大活动保障服务中，网宿屡次获得权威部门认可。</p>
  <p>网宿的服务对象几乎涵盖所有行业，全国前十大游戏公司有8家选择网宿，全国前十五大电商网站中有13家选择网宿，全国前15家社交咨询网站中有8家选择网宿，全国90%的视频直播网站选择网宿，超过50%的中央媒体选择网宿，全国十大证券公司中有6家选择网宿，五大国有银行全部选择网宿。</p>
  <p>网宿科技将继续以创新为驱动，以智能网络连接智慧未来。</p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-3.png')
  },
  desc: `<p>杭州虎符网络有限公司，是一家以阿里系和海归系为核心团队的网络安全公司。虎符网络拥有多名技术专家，公司创始人王伟，江湖ID：alert7，为原翰海源联合创始人兼CTO、前阿里安全技术总监，具有20年的网络攻防经验。</p>
  <p>虎符网络集安全咨询、安全研发、安全服务为一体，将为广大客户提供最有价值的企业级网络安全的产品和解决方案，希望通过零信任和攻防对抗的实践，助力广大企业构建新一代的企业安全。
  </p>`
}, {
  title: {
    pic: require('@/assets/images/member/member-4.png')
  },
  desc: `<p>盘古团队是由多名资深安全研究人员组成的专业安全研究团队。团队因连续多次发布iOS完美越狱工具而闻名，是国内首个自主实现苹果iOS完美越狱的团队，也是全球范围内第一个实现针对iOS 8和iOS 9系统完美越狱的团队。盘古越狱工具被全世界的用户下载数千万次。</p>
  <p>盘古团队成员兼具高水平学术理论研究和丰富的工业研发能力，在主流操作系统和重要应用程序中曾发现过数百个0day安全漏洞，研究成果多次发表在极具影响力的工业安全峰会 (Black Hat, CanSecWest, Syscan, RUXCON, HITCon, PoC, XCon)和顶级学术会议 (IEEE S&P, USENIX Security, ACM CCS, NDSS) 上，并于2015年成功举办了第一届MOSEC移动安全技术峰会。</p>
  <p>除了iOS系统安全研究，盘古团队不断吸纳资深安全研究人员，组建盘古安全实验室，在移动互联网领域开展了广泛的安全研究，深入探究移动设备的硬件、系统、应用和网络各层的安全架构，分析发现移动互联网大量潜在安全问题的同时，在高级防御技术及解决方案等方向上形成了一系列成果和产品。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-11.png')
  },
  desc: `<p>广东云智安信科技有限公司专注于高级威胁狩猎和网络安全事件应急响应等领域。公司成立初期即获得中国最大的网络安全公司奇安信的投资。云智安信公司面向关键基础设施企业和网络安全监管部门提供威胁狩猎、应急响应、高级威胁检测、威胁情报相关产品和服务。公司以“威胁情报驱动安全”的理念，开发了多款产品包括应急响应工具箱、监管部门网络安全态势感知平台、威胁狩猎平台等多款产品。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-12.png')
  },
  desc: `<p>烽台科技作为创新型工业信息安全企业，是国内率先以咨询评估和工业信息安全服务为主的高新技术公司，公司始终致力于工业控制系统和工业互联网相关的安全研究与实践，提高工业用户安全意识，保障国家工业关键信息基础设施安全。烽台科技以咨询、评估、服务、新技术研发为核心，紧密和监管单位、科研院所、测评机构、安全企业及工业企业进行合作，通过流程化、可视化、定制化的工具和方法，协助用户进行有效的风险管理与可靠的运营支撑。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-13.png')
  },
  desc: `<p>北京吉沃科技有限公司成立于北京，是一家专注于欺骗防御领域的创新型科技企业，公司核心成员均拥有多年国内一线安全公司管理经验和研发背景，有着丰富的网络安全产品设计、研发和安全攻防经验。
  公司自主研发有 “魔镜•智能仿真与诱捕防御系统”和“银河•开放式智能仿真众测平台”，致力于改变网络安全攻防不对称的现状，为客户提供多样化的欺骗防御产品和服务，提升客户网络安全的主动防御能力。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-14.png')
  },
  desc: `<p>福建中信网安信息科技有限公司成立于2015年，是一家集网络安全产品研发生产、安全服务与一体的高新技术企业，荣获福建省科技型企业称号。 中信网安福建省海峡信息技术有限公司的全国总代理，自有品牌“华创云盾”网络安全审计系统、网络入侵感知与防御系统均已获得国家公安部、国家信息安全产品认证中心的认证。中信网安以“致力于网络信息安全”为使命，网络入侵感知与防御系统信息安全守护者，重点围绕国家关键基础设施（电力、交通、能源等）；重要信息系统（金融、党政、财税、保险等）；重要公众服务（互联网+政务、互联网+金融、互联网+医疗、互联网+民生等）；重要监管单位（公安部、国家互联网应急响应中心、中国信息安全测评中心、等级保护测评中心等）为服务对象，秉承务实、正直、进取、创新的态度，为客户提供专业的信息安全一体化服务，与用户共创和享受安全美好的网络空间。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-15.png')
  },
  desc: `<p>北京金睛云华科技有限公司成立于2016年，注册资本金为1372万元人民币, 融资金额超过5000万。公司以“ AI驱动安全”为核心理念, 持续研发基于大数据人工智能技术的新一代网络安全产品, 包括高级威胁检测系统（ATD）、全流量回溯分析取证系统（TFS）、APT智能沙箱系统（AIS）、恶意加密流量检测系统（MED）、大数据安全分析与态势感知系统（CIC）、大数据威胁情报系统（CTI）、主机威胁取证系统（HTD）。目前已拥有十多项基于人工智能的安全技术专利，所服务的客户已超过500个，现网运行的系统已超过3000套，客户遍及公安、军队、金融、运营商、广电、政府、能源、电力、企业和高校等多个行业。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-16.png')
  },
  desc: `<p>杭州迪普科技股份有限公司（简称“迪普科技”） 以“让网络更简单、智能、安全”为使命，聚焦于网络安全及应用交付领域，是一家集研发、生产、销售于一体的高科技上市企业（股票代码：300768）。
  作为国内信息安全产业的重要厂商之一，迪普科技是国家信息安全漏洞库一级技术支撑单位、信息安全标准化技术委员会成员单位、中国网络安全产业联盟常务理事单位。同时，公司获得国家知识产权示范企业、国家重点软件企业、国家高新技术企业等多项荣誉。
  自成立以来，迪普科技坚持技术创新。公司拥有一支专业的软件开发及硬件逻辑开发团队，打造了独有的高性能分布式转发硬件架构和L2~7融合式操作系统。在此基础上，依托于安全研究团队十多年以来在攻防研究、漏洞挖掘、威胁情报分析、安全事件响应等技术积累，公司开发了具有自主知识产权的安全大数据处理引擎与AI智能分析引擎，结合主/被动安全检测、威胁情报、攻击建模等先进技术，构建了包括自安全网络、安全检测、安全分析、安全防护、安全服务、应用交付在内的产品体系，为客户提供全场景网络安全解决方案。
  在云计算、大数据、物联网、工业互联等新技术蓬勃发展的当下，迪普科技凭借在产品研发、安全研究及服务方面的深厚积累，率先推出高性能、高融合的云级业务核心平台及以此为基础的云安全解决方案；率先推出以“接入可信、行为可控”为理念的物联网安全管控解决方案；创新性的推出了“可视、可防、易运维”的自安全园区网解决方案。迪普科技致力于帮助各行各业客户构建新一代网络安全威胁感知及防护体系，实现威胁可视、智能溯源、自动防护；通过风险评估、安全保障、安全加固、应急响应、攻防演练、安全培训等专业服务，为客户提供全生命周期的安全运营保障。
  迪普科技的用户覆盖了政府、运营商、电力、能源、金融、交通、教育、医疗、企业等在内的各行各业，并承担了G20、APEC峰会、世界互联网大会等重大活动的网络安全保障支持。未来，迪普科技将继续在网络安全及应用交付领域持续投入，不断完善产品与解决方案，为客户创造更大价值。</p>`
},
{
  title: {
    pic: require('@/assets/images/member/member-17.png')
  },
  desc: `<p>赛博谛听，是一家由多位业内资深专家共同创建，基于云原生技术提供下一代网络和网络安全产品及云服务的创新型厂商。</p>`
}
// ,
// {
//   title: {
//     label: '新华三'
//   },
//   desc: `<p>网宿科技（300017）于2000年1月在中国上海成立，公司致力于大数据和云计算基础设施等方面的关键技术研究。公司在全球范围内构建了广泛高效的内容分发（CDN）、边缘计算网络，满足用户随时随地的数据计算及交互需求。</p>
//   <p>基于强大的数据分发及处理能力，网宿科技提供CDN、云安全、SD-WAN、云计算、边缘计算等丰富的产品及服务。网宿智能平台日均处理万亿级的服务请求，每天为全球网站抵御超过33亿次攻击，服务全球数十亿网民。</p>
//   <p>2019年，网宿科技实现营业收入60.08亿元亿元。在中国商用CDN市场中，网宿份额占比达31.5%，连续多年市场份额位列第一。</p>
//   <p>网宿科技在全球部署了超过1500个CDN节点、10+大型流量清洗中心，拥有广泛高效的资源储备，可承载超过15Tbps DDoS攻击，并与近100家海外运营商建立起合作关系，打通了跨网传输瓶颈，能够为各个行业、各大客户的定制化需求提供稳定、高效的服务。</p>
//   <p>网宿科技在美国、俄罗斯、韩国、中国厦门和中国深圳设立五大研发中心，拥有顶级的技术研发团队，研发人员数量占比超过65%，每年研发投入占公司营业收入10%左右。</p>
//   <p>网宿遍布六大洲的全球化运营平台同时为7*24小时的可靠服务保驾护航，其定制化服务能力在十九大、上合峰会、春晚、世界杯、电商购物节等多项重大活动中得到了验证。在历年来的重大活动保障服务中，网宿屡次获得权威部门认可。</p>
//   <p>网宿的服务对象几乎涵盖所有行业，全国前十大游戏公司有8家选择网宿，全国前十五大电商网站中有13家选择网宿，全国前15家社交咨询网站中有8家选择网宿，全国90%的视频直播网站选择网宿，超过50%的中央媒体选择网宿，全国十大证券公司中有6家选择网宿，五大国有银行全部选择网宿。</p>
//   <p>网宿科技将继续以创新为驱动，以智能网络连接智慧未来。</p>`
// }
]

export const chapters = [{
  title: '第一章: 总则',
  desc: `
一、联盟名称：联盟全称：网络安全威胁情报生态联盟 ，英文全称：Cybersecurity  Ecology Alliance of Threat Intelligence ，简称：CEATI

二、联盟性质：网络安全威胁情报生态联盟是由国内网络安全领军企业奇安信集团联合国内多家著名安全公司基于网络安全威胁情报生态建设的产业联盟的全国性社会组织。

三、联盟宗旨：遵守法律法规、遵守社会道德规范，秉承情报使能、开放合作、产业协同、共赢未来的宗旨，积极推动以威胁情报技术应用为核心行业生态建设，为中国网络安全事业做出贡献。

四、联盟接受中国网络空间安全协会行业管理和业务指导。

五、联盟内部实行民主管理

六、联盟总部（即联盟秘书处所在地）设在：北京市西城区西直门外南路26号院1号楼
  `
}, {
  title: '第二章: 联盟业务范围',
  desc: `
一、促进威胁情报技术在网络安全产业内多方面合作，协调联盟成员关系，建立并完善威胁情报产业链生态。

二、推动制定威胁情报产业的行业、国家或国际标准，使其在本行业或其他相关行业得到广泛的认可和推广，推动情报inside产品认证、情报质量检测等体系的建立和完善。

三、开展对威胁情报产业基础资料的调查、收集、统计、研究，向政府相关部门报告本行业发展情况及存在的问题，反映成员的愿望和诉求，提出行业发展建议，为政府制定相关产业政策提供依据。

四、搭建行业内威胁情报信息共享、数据运营、情报分发、威胁情报消费的行业闭环，以情报内生的方式促进行业资源有效利用和整合，对外开展技术咨询、分析报告、商业SDK等服务。

五、发展与国内外相关组织、企业的联系和交流，开展多种形式的交流与合作，维护威胁情报生态联盟利益和形象。

六、组织联盟内成员合理利用威胁情报技术互惠互利，防止行业不正当竞争，积极应对纠纷。

七、组织联盟内成员推动国内网络安全行业发展，营造良好的产业环境和舆论氛围。

八、开展有益于联盟行业发展的公益事业。

九、联盟致力于降低威胁情报消费门槛，用威胁情报技术促进网络安全行业发展。
  `
}, {
  title: '第三章: 联盟成员',
  desc: `
一、中国大陆境内具有独立法人资格、从事或准备从事网络安全产品研发、产品具备独立自主知识产权、具备自主业务渠道的企业、事业单位及相关机构，自有产品愿意集成使用联盟内至少1种情报能力同时承认本章程，均可向联盟秘书处提出申请。经批准后可以成为联盟正式成员，享受联盟成员权益和权利，承担联盟成员义务。

二、成员分为理事会成员（简称理事）和非理事会成员（简称成员）。
（一）理事会成员：
联盟发起人（联盟发起人是指积极参加联盟成立初期的活动，并自愿作为发起人的企事业单位及有关组织）为当然的理事会成员；承认本章程的非理事会成员，提出申请并经理事会成员提名，按照本章程的规定，由理事会决议通过，即可成为联盟理事会成员。
（二）非理事会成员：
承认本章程，向联盟提出申请并经理事会成员提名，按照本章程的规定，由理事会决议通过，即可成为联盟非理事会成员。

三、申请成为理事会成员：
  1） 为联盟成员；
  2） 对网络安全行业有重要贡献和影响力；
  3） 遵守适用于理事会成员的有关规定；
  4） 由理事会决议，并经全体理事会成员三分之二以上同意。

四、申请成为非理事会成员：
  1）承认联盟章程；
  2）有加入联盟的意愿；
  3）支持威胁情报行业生态发展；
  4）遵守联盟知识产权制度、禁止使用技术手段反向工程（逆向）其他产品SDK和其他联盟内规章制度；
  5）由理事会决议，并经全体理事会成员二分之一以上同意。

五、加入联盟应办理如下手续：
  （一）经理事会成员提名；
  （二）提交加入联盟的下列书面材料：
      1）加入联盟的申请；
      2）申请单位的介绍材料、公司法人证件复印件、公司营业执照复印件、产品软件著作权证书；
      3）申请单位的产品的威胁情报应用计划。
  （三）联盟秘书处对申请单位进行资格审查，并将意见提交理事会；
  （四）理事会讨论并做出决议；
  （五）联盟秘书处向获得同意的申请单位颁发成员证书

六、成员退出联盟应办理以下手续：
  （一）向联盟理事会提交书面退出声明，并交回成员证书；
  （二）自提交退出声明日三十日后退出联盟。成员退出后，已获得的成员权益即刻终止。
  （三） 1 个自然年内不参加联盟活动的，视为自动退出。

七、成员违反联盟章程及其他制度或做出不利于联盟的行为，并在接到理事会发出书面警告六十日内无改正行为，予以除名。成员除名后，会员权益即刻终止。成员被联盟除名后两年内不得再次申请加入联盟。

八、联盟成员享有以下权利：
  （一）非理事会成员：
      1）有权参加联盟大会，并享有选举权、被选举权和表决权；
      2）有权参加联盟组织的交流、培训、国际合作等活动；
      3）有权参加联盟组织的各工作组的活动；
      4）有权获得联盟提供的有关技术等相关资料；
      5）有权获得联盟提供的服务；
      6）有权向联盟提出建议和议案；
      7）有权申请成为理事会成员；
      8）有权退出联盟。
  （二）理事会成员：
      1）非理事会成员享有的权利；
      2）参加理事会会议，并享有选举权、被选举权和表决权；
      3）优先获得联盟服务的权利；
      4）向秘书长提议召开联盟大会临时会议和理事会临时会议；
      5）委派代表参加秘书处；
      6）有权向理事会反映问题，提出建议和议案；
      7）有权退出理事会或联盟。

九、联盟成员应尽以下义务：
  （一）非理事会成员：
      1）遵守联盟章程及规章制度，执行联盟的决议；
      2）积极承担和配合联盟委托的各项工作；
      3）积极参加联盟组织的活动；
      4）维护联盟的利益和合法权益；
      5）设立一名联络员，向联盟及时反映本单位的信息，提供成员的资料和变化情况；
      6）保守联盟商业秘密。
  （二）理事会成员：
      1）非理事会成员的义务；
      2）按时参加理事会的活动；
      3）积极完成理事会指定的任务；
      4）应秘书处的要求派代表参加秘书处的工作
  `
}, {
  title: '第四章: 组织机构和负责人产生',
  desc: `
一、联盟的最高权力机构是联盟大会，联盟大会每年召开一次，由联盟秘书长召集。联盟大会须有联盟成员的三分之二以上出席方能召开，除非另有规定，其决议须经到会成员半数以上表决通过方能生效。在联盟大会闭会期间，遇有重大或紧急情况，经理事会或半数以上成员提议，可召开联盟大会临时会议。

二、理事会是联盟的决策机构，对联盟大会负责。理事会成员的任期为三年，可以连任，首届理事会由联盟发起人组成，发起人理事具有一票否决权。理事会设立联合主席不超过三个，副主席若干，由理事会会议选举产生，任期为三年，可以连任，任期不超过两届。联合主席和副主席在理事会成员中选举产生。理事会会议每年召开一至二次，会议须有三分之二以上理事会成员出席方能召开。除非另有规定，其决议须经到会成员半数以上表决通过方能生效。在理事会闭会期间，遇有重大或紧急情况，经三名以上理事会成员提议，二分之一以上理事会成员同意，可以召开理事会临时会议。

三、理事会下设联盟秘书处，负责联盟的日常事务。联盟秘书处设秘书长一名，根据需要设置副秘书长若干名。秘书长、副秘书长每届任期为三年，可以连任，任期不超过两届。秘书长或经理事会认可的副秘书长为联盟法定代表人，向联盟大会及理事会负责，主持秘书处日常工作。

四、联盟大会及理事会联合主席、秘书长必须具备下列条件：
  （一）坚持国家的路线、方针、政策，政治素质好；
  （二）在国内网络安全领域内有较大影响；
  （三）最高任职年龄不超过 60 周岁；
  （四）身体健康，能正常开展本职工作；
  （五）未受过刑事处罚
  `
}, {
  title: '第五章: 联盟章程修改程序',
  desc: `
一、联盟章程的修改，须经三分之二以上的理事会成员表决通过后报联盟大会审议通过。

二、修改后的章程，须在联盟大会通过后 15 日内，国家指导单位部门备案。
  `
}, {
  title: '第六章: 附则',
  desc: `
一、任何在联盟内或由联盟讨论的内容，包括联盟大会、理事会会议、工作组会议议题和内容仅在成员内部是公开的。任何成员都应该遵守联盟的保密制度。

二、联盟所从事的所有活动均严格遵从所有现行的法律法规。联盟成员应知悉其各公司按一定的商业规则互相竞争，他们的行为不能违反任何现行的反垄断法律和法规。每位联盟成员应积极地鼓励和促进威胁情报生态的竞争环境。成员应确认他们不会竞争者之间谈论有关产品成本、产品定价、销售渠道、市场分区或客户配售等问题。因此，每位成员有责任为其参加联盟活动的代表就限制在正式会议或非正式聚会等场合谈论关于联盟目标宗旨的重要问题上提供相应法律的建议和忠告。每个成员还应知悉在符合联盟章程规定的范围内，开发竞争性的技术和标准以及将该成员的专利权许可给第三方以使竞争技术和标准进行运作的行为是自由的。

三、知识产权：任何成员不得因参加联盟而明示或默示地授予或被视为授予该联盟或其他成员关于专利、版权、商标、商业秘密或该成员拥有或控制的其他知识产权的任何权利或许可，除非本章程另有规定。未经其他成员的明示书面许可，任何成员不得以任何公开方式使用其他成员的名称，但是任何成员均可以披露和公开其在联盟的成员身份，并且联盟也可以披露和公开任何成员的成员身份，除非该成员以书面形式明示请求联盟不披露或公开其在联盟的成员身份。

四、此章程不是为了（也不应该被理解为）在成员之间建立一个公司、合伙企业、合资企业、代理关系等实体。任何成员在没有得到其他成员或联盟的书面授权时，都没有权利代表其他成员或联盟签订协议或承担义务。成员不应承担由其他成员或联盟的未授权行为带来的责任、损失或损害。

五、本章程自联盟大会表决通过后生效。

六、本联盟的官方语言为中文。本章程即使被翻译为其他语言，仍以中文版本为准。

七、本章程的解释权属于联盟理事会。

  `
}]

export const capabilities = [{
  title: '入门免费版',
  type: 'basic',
  items: [{
    title: '奇安信提供免费能力',
    type: 'qax-basic',
    features: [{
      title: '失陷（受害）主机检测能力',
      desc: `
能力说明：
  该能力适用于所有办公网、业务服务器区OUTBOND出站场景，针对该场景下的失陷受害主机定性研判拦截检测能力，免费版提供5万条最热度情报。适用：防火墙、NGFW、终端安全、服务器安全、UTM、云安全、态势感知、NGSOC、SD-WAN等产品。
集成方式：
  SDK动态库集成
商业模式：
  免费集成`
    }, {
      title: '告警日志富化能力',
      desc: `
能力说明：
  安全设备告警日志接口集成，通过告警IP、域名、URL、MD5哈希跳转联盟CEATI情报平台，提供对应的恶意TAG标签、反向解析域名、PDNS解析记录、域名whois信息，丰富传统安全设备告警日志不足，辅助事件响应分析人员研判分析和安全追溯。
集成方式：
  免登录认证API跳转
商业模式：
  免费集成
      `
    }]
  }]
}, {
  title: '商业进阶版',
  type: 'advance',
  items: [{
    title: '奇安信商业版能力',
    type: 'qax-advance',
    features: [{
      title: '失陷（受害）主机检测能力（商业版）',
      desc: `
能力说明：
  该能力适用于所有办公网、业务服务器区OUTBOND出站场景，针对该场景下的失陷受害主机定性研判拦截检测能力，商业版针对不同设备形态提供40万~100万条情报库。适用于：防火墙、NGFW、终端安全、服务器安全、UTM、云安全、态势感知、NGSOC、SD-WAN等产品。
集成方式：
  SDK动态库开发集成
商业模式：
  商业集成
      `
    }, {
      title: '面向网关设备的快速响应拦截能力（商业版）',
      desc: `
能力说明：
  该能力适用于INBOND入站场景，针对该场景下的设备快速响应拦截能力，商业版会提供小时级全网准实时可拦截类IP情报数据。适用于：WAF类检测拦截类产品。
集成方式：
  SDK动态库开发集成
商业模式：
  商业集成
      `
    }, {
      title: '告警日志富化能力（商业版）',
      desc: `
能力说明：
  安全设备告警日志接口集成，通过告警IP、域名、URL、MD5哈希跳转联盟CEATI情报平台，提供对应的恶意TAG标签、反向解析域名、PDNS解析记录、域名whois信息等更多专业能力，丰富传统安全设备告警日志不足，辅助事件响应分析人员研判分析和安全追溯。
集成方式：
  免登录认证API跳转开发集成
商业模式：
  商业集成
      `
    }, {
      title: '样本辅助鉴定能力（商业版）',
      desc: `
能力说明：
  安全设备捕获样本通过API接口云沙箱动静态辅助鉴定能力，该沙箱具备样本高对抗检测能力，已经经过Google VT集成和超过1年的海量样本对抗训练，可完美识别CS、MSF等框架生成的后门和木马。
集成方式：
  免登录认证API跳转开发集成
商业模式：
  商业集成
      `
    }]
  }, {
    title: '天际友盟商业版能力',
    type: 'tjym-advance',
    features: [{
      title: '全量实时明文数据下载',
      desc: `
能力说明：
  1) 全量、实时输出高时效性的威胁情报数据，包括IoCs和上下文情报数据，每日IoCs更新量2000W+；
  2) 情报数据种类包含：C&C节点、扫描器节点、病毒木马、恶意软件、勒索软件、钓鱼网址、色情站点、赌博站点、APT情报、恶意网站、垃圾邮件、漏洞爆发、安全漏洞、僵尸网络、Tor节点、被黑网站、恶意软件下载链接、数字货币；
  3) 适用于大型厂商，结合情报数据处置建议（单独提供）及不同产品线的情报数据消费需求，筛选出适用于不同产品的情报数据并集成到响应产品中；
集成方式：
  数据集成，通过API下载接口将明文情报数据下载到本地，通过厂商自有的更新源及更新机制将情报数据集成并内置到产品中；
商业模式：
  每用户每年收取全量数据服务费；
  每用户每年根据选择的情报数据种类收取服务费；
      `
    }, {
      title: '适用于网关类设备的IoCs',
      desc: `能力说明：
  1) 从全量实时威胁情报数据中筛选出适用于网关类设备检测及阻断的IoCs；
  2) IoC种类包含C&C节点、僵尸网络、APT情报、恶意软件、恶意网站、钓鱼网址、赌博站点、色情站点；
集成方式：
  数据集成，通过API下载接口把明文IoCs下载到本地，通过厂商自有的更新源及更新机制将情报数据集成并内置到产品中；
商业模式：
  1) 每用户按每年设备销售数量收取数据服务费；
  2) 合同有效期内设备销售数量小于等于最低承诺数量，按照最低承诺销售数量收取数据服务费；
  3) 合同有效期内设备销售数量大于最低承诺数量，按照实际销售数量收取数据服务费；
      `
    }, {
      title: '适用于流量检测类设备的IoCs及上下文情报',
      desc: `
能力说明：
  1) 从全量实时威胁情报数据中筛选出适用于流量检测类设备检测及阻断的IoCs及上下文情报；
  2) IoCs种类包含C&C节点、僵尸网络、数字货币、APT情报、恶意软件、恶意网站、钓鱼网址、Tor节点；
集成方式：
  数据集成，通过API下载接口把明文IoCs下载到本地，通过厂商自有的更新源及更新机制将情报数据集成并内置到产品中；
商业模式：
  1) 每用户按每年设备销售数量收取数据服务费；
  2) 合同有效期内设备销售数量小于等于最低承诺数量，按照最低承诺销售数量收取数据服务费；
  3) 合同有效期内设备销售数量大于最低承诺数量，按照实际销售数量收取数据服务费；
      `
    }, {
      title: '适用于SIEM类设备的IoCs及上下文情报',
      desc: `
能力说明：
  1) 从全量实时威胁情报数据中筛选出适用于SIEM类设备的IoCs及上下文情报；
  2) IoCs种类包含C&C节点、僵尸网络、数字货币、APT情报、恶意软件、恶意网站、钓鱼网址、Tor节点、扫描器节点、垃圾邮件、恶意软件下载链接；
集成方式：
  数据集成，通过API下载接口把明文IoCs下载到本地，通过厂商自有的更新源及更新机制将情报数据集成并内置到产品中；
商业模式：
  1) 每用户按每年设备销售数量收取数据服务费；
  2) 合同有效期内设备销售数量小于等于最低承诺数量，按照最低承诺销售数量收取数据服务费；
  3) 合同有效期内设备销售数量大于最低承诺数量，按照实际销售数量收取数据服务费；
      `
    }, {
      title: '在线查询',
      desc: `
能力说明：
  通过页面或接口的方式，针对提交的IP、URL、Email、Domain、MD5、字符串，提供历史评定记录及其关联信息
集成方式：
  1) 接口集成，安全产品内置查询接口，按需调用查询接口发送需要查询的字段，并通过结果返回接口接收查询结果；
  2) 页面集成，安全产品在界面上通过单点登录的方式，调用云端查询页面查看查询结果
商业模式：
  按查询次数收取数据查询服务费；
      `
    }]
  }]
}]
export const tipDialogtext = {
  apply: {
    title: '适用范围',
    content: () => {
      return '<p>1、设备要求：此离线包的导入，需您的安全设备支持Stix2.1标准（需要咨询您的安全设备厂家）。</p><p>2、适用场景参考：通过内部的DNS日志或者HTTP上网日志，获得相关的域名或URL信息，可以利用失陷检测离线包的情报进行内部失陷主机的发现和拦截。<p>'
    }
  },
  installation: {
    title: '安装说明',
    content: () => {
      return '<p>您可以选择在页面手动直接下载离线包，或者通过密钥的方式进行接口请求。</p><br/><p>1、手动下载离线包方式：</p><p>• 您可以直接点击下载按钮，将离线包下载到本地。</p><p>• 下载离线包后，按Stix2.1的规范解析即可使用。</p><br/><p>2、接口请求方式：</p><p>• 您可以在页面点击【密钥下载】请求，我们会将使用密钥下载说明发送到您的注册邮箱。</p><p>• 您可以使用密钥访问失陷检测开源API，自动请求获取当前离线资源包。</p><p>• 密钥数据展示在您的用户基本信息页面，由奇安信威胁情报中心统一颁发。</p><br/><p>注意：使用此离线包，请确认您的安全设备是否支持Stix2.1标准（需要咨询您的安全设备厂家），支持相关安全设备订阅和离线包导入！</p>'
    }
  },
  application: {
    title: '提交申请通知',
    content: (data) => {
      return `<p>尊敬的用户，您好！</p><br/><p>资源包密钥信息及使用说明，已经发送到您的邮箱<span style="color:blue">${data.email}</span>,请注意查收。</p><p>若长时间未收到邮件，您可以重新提交申请，或者联系我们ti_support@qianxin.com</p>`
    }
  }
}
export const intelDialogText = {
  apply: {
    title: '适用范围',
    content: () => {
      return '<p>1、设备要求：此离线包的导入，需您的安全设备支持Stix2.1标准（需要咨询您的安全设备厂家）。</p><p>2、适用场景参考：使用内往外的DNS、HTTP访问或者TCP/UDP日志提取相应的domain、dst_ip/dst_port或者host/URL信息，与挖矿情报匹配，从而对内部疑似挖矿行为进行检测发现或者拦截。<p>'
    }
  },
  installation: {
    title: '安装说明',
    content: () => {
      return '<p>您可以选择在页面手动直接下载离线包，或者通过密钥的方式进行接口请求。</p><br/><p>1、手动下载离线包方式：</p><p>• 您可以直接点击下载按钮，将离线包下载到本地。</p><p>• 下载离线包后，按Stix2.1的规范解析即可使用。</p><br/><p>2、接口请求方式：</p><p>• 您可以在页面点击【密钥下载】请求，我们会将使用密钥下载说明发送到您的注册邮箱。</p><p>• 您可以使用密钥访问挖矿情报开源API，自动请求获取当前离线资源包。</p><p>•  密钥数据展示在您的用户基本信息页面，由奇安信威胁情报中心统一颁发。</p><br/><p>注意：使用此离线包，请确认您的安全设备是否支持Stix2.1标准（需要咨询您的安全设备厂家），支持相关安全设备订阅和离线包导入！</p>'
    }
  },
  application: {
    title: '提交申请通知',
    content: (data) => {
      return `<p>尊敬的用户，您好！</p><br/><p>资源包密钥信息及使用说明，已经发送到您的邮箱<span style="color:blue">${data.email}</span>,请注意查收。</p><p>若长时间未收到邮件，您可以重新提交申请，或者联系我们ti_support@qianxin.com</p>`
    }
  }
}
export const login = {
  title: 'CEATI联盟',
  desc: '情报使能、共谋共策、开放合作、共赢未来'
}
function spaceValidate (value, cb, name) {
  let reg = /\s+/g
  if (reg.exec(value) !== null) {
    cb(new Error(`${name}不能包含空格!`))
  }
}
export const formRules = {
  // 空格校验
  spaceValidate: (name) => {
    return (rule, value, cb) => {
      if (!value) cb(new Error(`${name}不能为空!`))
      spaceValidate(value, cb, name)
      cb();
    }
  },
  userNameValid: (rule, value, cb) => {
    if (!value) cb(new Error('用户名不能为空!'));
    spaceValidate(value, cb, '用户名')
    if (value.length > 20) cb(new Error('用户名长度不能超过20个字符!'));
    cb();
  },
  emailValid: (rule, value, cb) => {
    if (!value) cb(new Error('邮箱不能为空!'));
    spaceValidate(value, cb, '邮箱')
    let reg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
    if (!reg.test(value)) {
      cb(new Error('请输入正确的邮箱格式!'));
    }
    cb();
  },
  passwordValid: (rule, value, cb) => {
    // 密码长度12位以上,20位以下
    // 密码包含数字、大小写字母、特殊符号
    if (!value) cb(new Error('密码不能为空!'))
    if (value.length < 12) cb(new Error('密码不能低于12个字符!'))
    if (value.length > 20) cb(new Error('密码不能多于20个字符!'))
    spaceValidate(value, cb, '密码')
    // eslint-disable-next-line no-useless-escape
    let reg = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~`!@#$%^&*()_\\\-+={\[\]}\|:;"'<,>.?\/])).{12,20}$/
    // let reg = /\d+/g
    // let regSpecial = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+/g
    // let regCharacter1 = /[a-z]+/g
    // let regCharacter2 = /[A-Z]+/g

    if (!reg.test(value)) {
      cb(new Error('密码必须包含数字、大小写字母与特殊字符!'))
    }
    cb();
    // if (!value) cb(new Error('密码不能为空!'))
    //   // if (value.length < 6) cb(new Error('请输入6～10位数字或英文字符!'))
    //   // if (value.length > 10) cb(new Error('请输入6～10位数字或英文字符!'))

    //   let reg = /^[\w]{6,10}$/g
    //   if (!reg.test(value)) {
    //     cb(new Error('请输入6～10位数字或英文字符!'))
    //   }
    //   cb();
  }

}
